import axios from '@/plugins/axios';
import { Notifications, NotificationType, NotificationCountType } from '@/models/Notification';

const FAKE_NOTIFICATION_RESULT = false;

const FAKE_NOTIFICATION_DATA:Notifications = {
  [NotificationType.Messages]: {
    [NotificationCountType.DirectMessage]: 5,
    [NotificationCountType.ForumMessage]: 3,
    [NotificationCountType.ProjectMessage]: 2,
    [NotificationCountType.ChatGroupMessage]: 2,
  },
  [NotificationType.Projects]: {
    [NotificationCountType.NewProjectChanges]: 2,
    [NotificationCountType.NewProjectComments]: 3,
    [NotificationCountType.NewProjects]: 3,
    [NotificationCountType.NewRecommendations]: 3, // unclearable
    [NotificationCountType.NewRecommendationFeedbacks]: 5,
    [NotificationCountType.ChangedProjectOffers]: 2, // unclearable
    [NotificationCountType.NewProjectOffers]: 1, // unclearable
  },
  [NotificationType.Talks]: {
    [NotificationCountType.NewTalkComments]: 3,
    [NotificationCountType.NewTalks]: 2,
  },
  [NotificationType.Contracts]: {
    [NotificationCountType.NewContracts]: 1,
    [NotificationCountType.ChangedContracts]: 3,
  },
  [NotificationType.Invoices]: {
    [NotificationCountType.NewInvoices]: 18,
    [NotificationCountType.ChangedInvoices]: 2,
  },
  [NotificationType.Meetings]: {
    [NotificationCountType.NewMeetingInvitations]: 1,
  },
};

// eslint-disable-next-line import/prefer-default-export
export async function getAllNotifications(): Promise<Notifications | null> {
  return (FAKE_NOTIFICATION_RESULT) ? structuredClone(FAKE_NOTIFICATION_DATA) : (await axios.get('/v1/notifications/widget/overview').catch(() => null))?.data ?? null;
}

export async function clearNotification(type: NotificationCountType | '') {
  const translation: Partial<Record<NotificationCountType, string>> = {
    [NotificationCountType.ProjectMessage]: 'MESSAGING_PROJECT',
    [NotificationCountType.DirectMessage]: 'MESSAGING_PRIVATE',
    [NotificationCountType.ForumMessage]: 'MESSAGING_TALK',
    [NotificationCountType.ChatGroupMessage]: 'MESSAGING_CHATGROUP',

    [NotificationCountType.NewTalks]: 'SUBSCRIPTION_FORUMTHREAD_NEW',
    [NotificationCountType.NewTalkComments]: 'SUBSCRIPTION_FORUMTHREAD_MESSAGE_NEW',

    [NotificationCountType.NewProjects]: 'SUBSCRIPTION_PROJECTS_NEW',
    [NotificationCountType.NewProjectComments]: 'SUBSCRIPTION_PROJECT_MESSAGE_NEW',
    [NotificationCountType.NewProjectChanges]: 'SUBSCRIPTION_PROJECT_CHANGED',
    [NotificationCountType.NewRecommendations]: 'RECOMMENDATIONS_NEW',
    [NotificationCountType.NewRecommendationFeedbacks]: 'RECOMMENDATION_FEEDBACK_NEW',

    [NotificationCountType.NewContracts]: 'CONTRACTS_NEW',
    [NotificationCountType.ChangedContracts]: 'CONTRACTS_CHANGED',

    [NotificationCountType.NewInvoices]: 'INVOICES_NEW',
    [NotificationCountType.ChangedInvoices]: 'INVOICES_CHANGED',

    [NotificationCountType.NewMeetingInvitations]: 'MEETING_INVITATIONS_NEW'
  };

  return axios.post('/v1/notifications/widget/clear', { type: type ? translation[type] : 'ALL' });
}

export async function clearNotifications(which: NotificationType | ''): Promise<void> {
  const availableClearances: Partial<Record<NotificationType, NotificationCountType[]>> = {
    [NotificationType.Talks]: [
      NotificationCountType.NewTalkComments,
      NotificationCountType.NewTalks
    ],
    [NotificationType.Messages]: [
      NotificationCountType.DirectMessage,
      NotificationCountType.ProjectMessage,
      NotificationCountType.ForumMessage,
      NotificationCountType.ChatGroupMessage
    ],
    [NotificationType.Projects]: [
      NotificationCountType.NewProjects,
      NotificationCountType.NewProjectComments,
      NotificationCountType.NewProjectChanges,
      NotificationCountType.NewRecommendations,
      NotificationCountType.NewRecommendationFeedbacks
    ],
    [NotificationType.Contracts]: [
      NotificationCountType.NewContracts,
      NotificationCountType.ChangedContracts
    ],
    [NotificationType.Invoices]: [
      NotificationCountType.NewInvoices,
      NotificationCountType.ChangedInvoices
    ],
    [NotificationType.Meetings]: [
      NotificationCountType.NewMeetingInvitations
    ]

  };

  if (!which) await clearNotification('');
  else {
    const clearances: NotificationCountType[] = availableClearances?.[which] ?? [];
    if (!clearances.length) throw new Error(`NO CLEARANCES FOUND FOR ${which}!!!`);
    const clearancePromises = clearances.map((clearance) => clearNotification(clearance));
    await Promise.all(clearancePromises);
  }
}
